import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Crown, MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/5573981988263";

const VitrineCTASection = () => {
  return (
    <section className="relative overflow-hidden rounded-3xl border border-yellow-500/30 bg-gradient-to-br from-zinc-900 via-black to-zinc-900 p-8 md:p-12 text-center">
      <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl" />
      <div className="relative z-10 max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-extrabold text-white">
          Pronto para <span className="bg-gradient-to-r from-yellow-400 to-amber-500 bg-clip-text text-transparent">turbinar seus jogos?</span>
        </h2>
        <p className="mt-3 text-zinc-300">
          Assine agora e desbloqueie todos os métodos, IA, estatísticas e muito mais.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/planos">
            <Button size="lg" className="bg-gradient-to-r from-yellow-500 to-amber-500 text-black hover:from-yellow-600 hover:to-amber-600 font-bold w-full sm:w-auto">
              <Crown className="mr-2 h-5 w-5" /> Ver planos
            </Button>
          </Link>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            <Button size="lg" variant="outline" className="border-emerald-500/50 text-emerald-400 hover:bg-emerald-500/10 w-full sm:w-auto">
              <MessageCircle className="mr-2 h-5 w-5" /> Falar com suporte
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default VitrineCTASection;
